var defaultDisplayRender = function (label) { return label.join(' / '); };
export var defaultProps = {
    className: '',
    data: [],
    defaultValue: undefined,
    value: undefined,
    fieldNames: {
        label: 'label',
        value: 'value',
        children: 'children',
    },
    displayRender: defaultDisplayRender,
    showSearch: false,
    onChange: function (value, selectedOptions) { },
    onBeforeChange: function () { return true; },
    placeholder: '请选择',
    disabled: false,
    notFoundContent: '暂无数据',
    changeOnSelect: false,
    showPopper: false,
    expandTrigger: 'click',
    size: 'normal',
    loadData: function (selectOptions) { },
};
